import React, { createContext } from "react";
import { useNavigate } from "react-router-dom";

export const StoreContext = createContext(null);

// eslint-disable-next-line
export default ({ children }) => {
  const navigate = useNavigate();

  const redirect = (years) => {
    if(!years) {
      return [window.location.reload(), setTimeout( ()=> { navigate("/checking-year") }, 0 )];
    } else if(years < 18){
      return [window.location.reload(), setTimeout( ()=> { navigate("/under-age") }, 0 ) ];
    } else {
      return [window.location.reload(), setTimeout( ()=> { navigate("/under-age") }, 0 ) ];
    }
  };

  const value = {
    redirect
  };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};
